import {useNavigate} from "react-router-dom";
import {Button, ThemeProvider} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React, {useEffect, useState} from "react";
import mainTheme from "../../styles/theme";

const BackButton = () => {
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const previousPage = sessionStorage.getItem("previousPage");
        setIsVisible(!!previousPage);
    }, []);

    const handleBack = () => {
        sessionStorage.setItem("fromBack", "true");
        const previousPage = sessionStorage.getItem("previousPage") || "/";
        const scrollY = sessionStorage.getItem("scrollPosition") || 0;

        navigate(previousPage);
        setTimeout(() => {
            window.scrollTo(0, scrollY);
        }, 0);
    };

    if (!isVisible) return null; // Hide if no previous page

    return (
        <ThemeProvider theme={mainTheme}>
            <Button
                variant="contained"
                color='secondary'
                onClick={handleBack}
                sx={{
                    position: "fixed", // Stays in the same place when scrolling
                    bottom: {xs: 16, sm: 24}, // Adjust bottom spacing for mobile and desktop
                    left: {xs: 16, sm: 24}, // Adjust left spacing
                    zIndex: 1000, // Keeps it above other elements
                    boxShadow: 3,
                    borderRadius: "50px",
                    padding: "5px 5px",
                    minWidth: '24px',
                    "&:hover": {
                        backgroundColor: "secondary.dark",
                    },
                }}
            >
                <ArrowBackIcon/>
            </Button>
        </ThemeProvider>

    );
};

export default BackButton;
